import React from "react";

export function DropDownIcon() {
    return <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M6.928 6.76267C6.464 7.38133 5.536 7.38133 5.072 6.76267L1.392 1.856C0.818464 1.09129 1.36411 0 2.32 0L9.68 0C10.6359 0 11.1815 1.09129 10.608 1.856L6.928 6.76267Z" fill="#3EC1CB"/>
    </svg>;
}
